<template>
  <div v-if="!isLoading && list.length">
    <div class="d-flex justify-content-between flex-column">
      <Table style="margin-top: 1rem;" class="leads-table">
        <TableHeader>
          <TableRow class="header-loss-cause">
            <TableHead colspan="2"></TableHead>
            <TableHead colspan="1"></TableHead>
            <TableHead colspan="1"></TableHead>
            <TableHead colspan="1"></TableHead>
            <TableHead colspan="7">MOTIVOS DE PERDA</TableHead>
          </TableRow>
          <TableRow>
            <TableHead
              v-for="(leadsCol, index) in leadsColumns"
              :key="`${leadsCol}-${index}`"
            >
              <ColumnHeader
                :sort="leadsCol.sort"
                :somatory="leadsCol.somatory"
                :columnName="leadsCol.name"
                :columnKey="leadsCol.key"
                :columnType="leadsCol.columnType"
                :currentColumnFiltered="currentColumnFiltered"
                :sortDirection="sortDirection"
                :dataList="list"
                @sortListByKey="sortListByKey(leadsCol.key)"
              />
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow v-for="(item, idx) in list" :key="`${item}-${idx}`">
            <TableCell>
              <RenderDateColumnValue :value="item.creationDate" />
            </TableCell>
            <TableCell
              ><RenderNameColumnValue
                :name="item.primaryCNAECode + '-' + item.primaryCNAEDescription"
            /></TableCell>
            <TableCell
              >{{ (item.totalQualified / item.totalLeads) * 100 }}%
            </TableCell>
            <TableCell>{{ item.totalLeads }}</TableCell>
            <TableCell>{{ item.totalQualified }}</TableCell>
            <TableCell>{{ item.totalClosed }}</TableCell>
            <TableCell>{{ item.totalMT }}</TableCell>
            <TableCell>{{ item.totalLowConsumption }}</TableCell>
            <TableCell>{{ item.totalSCEEWithoutICMSWithBalance }}</TableCell>
            <TableCell>{{ item.totalSCEEExemptWithBalance }}</TableCell>
            <TableCell>{{ item.totalNightIrrigator }}</TableCell>
            <TableCell>{{ item.totalNoHistory }}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  </div>
</template>

<script>
import {
  RenderDateColumnValue,
  RenderNameColumnValue,
} from '../../../../ui/render';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../../ui/table';
import { defineArrowDirection, sortByProperty } from '../../../../utils';
import { ColumnHeader } from '../../../../ui/column-header';
import { Api } from '../../../../vue/api';
import { BaseButtonComponent } from '../../../../ui/buttons';
const API = new Api();

export default {
  components: {
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    ColumnHeader,
    RenderNameColumnValue,
    RenderDateColumnValue,
    BaseButtonComponent,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      qualificationTypeInBatch: null,
      selectedLeads: [],
      leadsColumns: [
        {
          name: 'Data feita',
          key: 'creationDate',
          sort: true,
          somatory: false,
        },
        {
          name: 'CNAE Primário',
          key: 'primaryCNAE',
          sort: true,
          somatory: false,
        },
        {
          name: 'Indice de conversão',
          key: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Leads analisados',
          key: 'totalLeads',
          sort: false,
          somatory: false,
        },
        {
          name: 'Leads qualificados',
          key: 'totalQualified',
          sort: false,
          somatory: false,
        },
        {
          name: 'Sem UC/Encerrada',
          key: 'totalClosed',
          sort: false,
          somatory: false,
        },

        {
          name: 'MT',
          key: 'totalMT',
          sort: false,
          somatory: false,
        },
        {
          name: 'Consumo baixo',
          key: 'totalLowConsumption',
          sort: false,
          somatory: false,
        },
        {
          name: 'SCEE s/ ICMS c/ saldo',
          key: 'totalSCEEWithoutICMSWithBalance',
          sort: false,
          somatory: false,
        },
        {
          name: 'SCEE isenta c/ saldo',
          key: 'totalSCEEExemptWithBalance',
          sort: false,
          somatory: false,
        },
        {
          name: 'Irrigante noturno',
          key: 'totalNightIrrigator',
          sort: false,
          somatory: false,
        },
        {
          name: 'Sem histórico de contas',
          key: 'totalNoHistory',
          sort: false,
          somatory: false,
        },
      ],
      currentColumnFiltered: '',
      sortDirection: 'ASC',
      busyButton: false,
      busy: false,
    };
  },
  methods: {
    showToast(message, title = 'Aviso', variant = 'info') {
      this.$bvToast.toast(message, { title, variant, solid: true });
    },
    sortListByKey(columnKey) {
      this.sortDirection = defineArrowDirection(
        this.currentColumnFiltered,
        columnKey,
        this.sortDirection,
      );
      this.currentColumnFiltered = columnKey;
      sortByProperty(this.list, columnKey, this.sortDirection);
    },
  },
};
</script>

<style lang="scss" scoped>
.leads-table {
  display: block;
  max-height: 48vh !important;
  height: auto !important;
  overflow-x: auto;

  th:first-child,
  td:first-child {
    z-index: 2;
    position: sticky;
    left: 0;
    background-color: #e7e7e7;
  }

  td:nth-child(2),
  th:nth-child(2) {
    z-index: 2;
    position: sticky;
    left: 6.6rem;
    background-color: #e7e7e7;
  }

  td:nth-child(3),
  th:nth-child(3) {
    z-index: 2;
    position: sticky;
    left: 22.2rem;
    background-color: #71b6f4;
    text-align: center;
  }
  td:nth-child(4),
  th:nth-child(4) {
    z-index: 2;
    position: sticky;
    left: 31.8rem;
    background-color: #f1c146;
    text-align: center;
  }

  td:nth-child(5),
  th:nth-child(5) {
    z-index: 2;
    position: sticky;
    left: 40.2rem;
    background-color: #7bfe79;
    text-align: center;
  }

  .header-loss-cause {
    th:first-child {
      z-index: 3;
      position: sticky;
      left: 0;
      background-color: #e7e7e7;
    }

    th:nth-child(2) {
      z-index: 3;
      position: sticky;
      left: 22.2rem;
      background-color: #71b6f4;
    }

    th:nth-child(3) {
      z-index: 3;
      position: sticky;
      left: 31.8rem;
      background-color: #f1c146;
    }

    th:nth-child(4) {
      z-index: 3;
      position: sticky;
      left: 40.2rem;
      background-color: #7bfe79;
    }

    th:nth-child(5) {
      position: initial;
      background-color: #fd9a70;
      text-align: center;
    }
  }

  td:nth-child(6),
  th:nth-child(6),
  td:nth-child(7),
  th:nth-child(7),
  td:nth-child(8),
  th:nth-child(8),
  td:nth-child(9),
  th:nth-child(9),
  td:nth-child(10),
  th:nth-child(10),
  td:nth-child(11),
  th:nth-child(11),
  td:nth-child(12),
  th:nth-child(12) {
    background-color: #fd9a70;
    text-align: center;
  }

  tr:nth-child(odd) td:nth-child(-n + 12) {
    background-color: #fd9a70;
  }
  tr:nth-child(even) td:nth-child(-n + 12) {
    background-color: #f5b296;
  }
  tr:nth-child(odd) td:nth-child(-n + 2) {
    background-color: #e7e7e7;
  }
  tr:nth-child(even) td:nth-child(-n + 2) {
    background-color: #f2f2f2;
  }

  tr:nth-child(odd) td:nth-child(3) {
    background-color: #71b6f4;
  }
  tr:nth-child(even) td:nth-child(3) {
    background-color: #9acdfa;
  }

  tr:nth-child(odd) td:nth-child(4) {
    background-color: #f1c146;
  }
  tr:nth-child(even) td:nth-child(4) {
    background-color: #f0cc71;
  }

  tr:nth-child(odd) td:nth-child(5) {
    background-color: #7bfe79;
  }
  tr:nth-child(even) td:nth-child(5) {
    background-color: #a7fda6;
  }
}
</style>
